export enum BetType {
  Single,
  Express,
  System
}
